import React from "react";
import SkillCategoryCard from "../../components/cards/SkillCategoryCard";

function ExpertiseSection() {
  const expertiseData = [
    {
      title: "Backend Engineering",
      skills: [
        "Python",
        "Flask",
        "Golang",
        "REST APIs",
        "PostgreSQL",
        "System Architecture",
      ],
    },
    {
      title: "Frontend Engineering",
      skills: [
        "React.js",
        "Next.js",
        "TypeScript",
        "Tailwind CSS",
        "Material UI",
        "SSR",
      ],
    },
    {
      title: "Artificial Intelligence",
      skills: [
        "Machine Learning",
        "Computer Vision",
        "PyTorch",
        "YOLO",
        "OpenCV",
        "LLM Integration",
      ],
    },
    {
      title: "Infrastructure & DevOps",
      skills: ["Docker", "Linux", "Nginx", "CI/CD", "VPS Deployment", "Git"],
    },
  ];

  return (
    <section
      id="expertise"
      className="bg-transparent p-4 sm:p-8 font-sans border-t border-slate-900/10 mt-12"
    >
      <div className="mx-auto max-w-7xl w-full">
        {/* Section Header */}
        <div className="mb-10 max-w-xl">
          <span className="text-xs font-bold uppercase tracking-widest text-gsf-bronze">
            Capabilities Matrix
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mt-1 tracking-tight">
            Technical Expertise
          </h2>
          <p className="text-sm text-slate-600 font-medium mt-2 leading-relaxed">
            A precise structural decomposition of systems, engineering
            frameworks, and technical environments I operate in.
          </p>
        </div>

        {/* Grid Layout untuk Kategori */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {expertiseData.map((category, index) => (
            <SkillCategoryCard
              key={index}
              title={category.title}
              icon={category.icon}
              skills={category.skills}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ExpertiseSection;
